// extracted by mini-css-extract-plugin
export default {"loading-field":"SkeletonLoadingField_loading-field__r7Mke","loading-field-wrapper":"SkeletonLoadingField_loading-field-wrapper__0+O5h"};